import { Link } from '@mui/material'
import { MouseEvent } from 'react'
import {
  sanitizeFieldRestProps,
  TextFieldProps,
  useFieldValue,
  useRecordContext
} from 'react-admin'
import useSales from '../hooks/useSales'
import useAlert from '../../../components/Alert/hooks/useAlert'

const LINK_COPIED_MESSAGE = {
  success: 'Link copied to clipboard',
  error: 'Failed to copy link to clipboard'
}

const SaleNameField = (props: TextFieldProps) => {
  const record = useRecordContext()
  const { alertSuccess, alertError } = useAlert()
  const { getSaleLink, sendLinkCopiedEvent } = useSales()
  const { className, ...rest } = props
  const value = useFieldValue(props)

  const handleCopy = async (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const link = getSaleLink({ slug: record?.slug }) || ''

    navigator.clipboard
      .writeText(link)
      .then(() => {
        alertSuccess(LINK_COPIED_MESSAGE.success)
        sendLinkCopiedEvent(record?.id as number)
      })
      .catch(() => alertError(LINK_COPIED_MESSAGE.error))
  }

  return (
    <Link
      className={className}
      href=""
      variant="body2"
      onClick={handleCopy}
      {...sanitizeFieldRestProps(rest)}
    >
      {value}
    </Link>
  )
}

export default SaleNameField
